import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Label,
  Input
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardReturnDrugWorkingUX = (props: any) => {
    return(
      <div
        id="CardReturnDrugWorkingUX-div-0"
        style={{width:"100%", padding: "10px",  height: "100%"}}>
        <div
          className="ui form"
          id="CardReturnDrugWorkingUX-div-1"
          style={{display: "flex", alignItems: "center"}}>

          <div
            className="ui label brown ribbon"
            id="CardReturnDrugWorkingUX-div-92">
            {props.DrugReturnRequestHistorySequence?.selectedBox?.code || "-"}
          </div>
          <div
            id="CardReturnDrugWorkingUX-div-2">

            <div
              id="CardReturnDrugWorkingUX-div-3"
              style={{fontWeight: "bold", fontSize: "1.2rem"}}>
              {props.languageUX === "en" ? "Return the medicine to the pharmacy." : "คืนยากลับเข้าห้องยา"}
            </div>
          </div>
          <div
            id="CardReturnDrugWorkingUX-div-94"
            style={{flex: 1}}>

          </div>
          <Label
            id="CardReturnDrugWorkingUX-Label-93">
            {props.DrugReturnRequestHistorySequence?.selectedBox?.status_name || "-"}
          </Label>
        </div>
        <div
          className="ui form"
          id="CardReturnDrugWorkingUX-div-5"
          style={{marginBottom: "1.5rem"}}>

          <FormGroup
            id="CardReturnDrugWorkingUX-FormGroup-6"
            inline={true}>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-7"
              inline={true}>
              <label
                id="CardReturnDrugWorkingUX-label-9">
                {props.languageUX === "en" ? "Drug leaf number" : "เลขที่ใบยา"}
              </label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-8"
              inline={true}>
              <Label
                className="large"
                id="CardReturnDrugWorkingUX-Label-10"
                style={{backgroundColor: "#C3F4FF", color: "rgba(0,0,0,.87)"}}>
                {props.DrugReturnRequestHistorySequence?.selectedBox?.order_code || "-"}
              </Label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-125"
              inline={true}>
              <label
                id="CardReturnDrugWorkingUX-label-126">
                {props.languageUX === "en" ? "patient" : "ผู้ป่วย"}
              </label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-130"
              inline={true}>
              <Label
                className="large"
                id="CardReturnDrugWorkingUX-Label-131"
                style={{backgroundColor: "#C3F4FF", color: "rgba(0,0,0,.87)"}}>
                {props.DrugReturnRequestHistorySequence?.selectedBox?.patient_name_code || "-"}
              </Label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-128"
              inline={true}>
              <label
                id="CardReturnDrugWorkingUX-label-129">
                {props.languageUX === "en" ? "Agency" : "หน่วยงาน"}
              </label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-132"
              inline={true}>
              <Label
                className="large"
                id="CardReturnDrugWorkingUX-Label-133"
                style={{backgroundColor: "#C3F4FF", color: "rgba(0,0,0,.87)"}}>
                {props.DrugReturnRequestHistorySequence?.selectedBox?.requester_name || "-"}
              </Label>
            </FormField>
          </FormGroup>
        </div>
        <div
          className="ui form"
          id="CardReturnDrugWorkingUX-div-11">

          <FormGroup
            id="CardReturnDrugWorkingUX-FormGroup-27"
            inline={true}>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-30"
              inline={true}>
              <label
                id="CardReturnDrugWorkingUX-label-42"
                style={{width: "70px"}}>
                {props.languageUX === "en" ? "Refund Requester" : "ผู้ขอคืน"}
              </label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-31"
              inline={true}
              width={3}>
              <Input
                fluid={true}
                id="CardReturnDrugWorkingUX-Input-48"
                ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#DFDFDF",ref.inputRef.current.style.borderColor = "#DBDBDB")}
                style={{width: "100%"}}
                value={props.DrugReturnRequestHistorySequence?.selectedBox?.requested?.name || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-32"
              inline={true}>
              <label
                id="CardReturnDrugWorkingUX-label-43">
                {props.languageUX === "en" ? "Day-time" : "วัน-เวลา"}
              </label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-33"
              inline={true}
              width={3}>
              <Input
                fluid={true}
                id="CardReturnDrugWorkingUX-Input-49"
                ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#DFDFDF",ref.inputRef.current.style.borderColor = "#DBDBDB")}
                style={{width: "100%"}}
                value={props.orderDatetime?.requested || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-104"
              inline={true}>
              <label
                id="CardReturnDrugWorkingUX-label-105">
                {props.languageUX === "en" ? "department" : "แผนก"}
              </label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-112"
              inline={true}
              width={3}>
              <Input
                fluid={true}
                id="CardReturnDrugWorkingUX-Input-113"
                ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#DFDFDF",ref.inputRef.current.style.borderColor = "#DBDBDB")}
                style={{width: "100%"}}
                value={props.DrugReturnRequestHistorySequence?.selectedBox?.requested?.division || ""}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardReturnDrugWorkingUX-FormGroup-28"
            inline={true}>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-34"
              inline={true}>
              <label
                id="CardReturnDrugWorkingUX-label-44"
                style={{width: "70px"}}>
                {props.languageUX === "en" ? "Approver" : "ผู้อนุมัติ"}
              </label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-35"
              inline={true}
              width={3}>
              <Input
                fluid={true}
                id="CardReturnDrugWorkingUX-Input-50"
                ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#DFDFDF",ref.inputRef.current.style.borderColor = "#DBDBDB")}
                style={{width: "100%"}}
                value={props.DrugReturnRequestHistorySequence?.selectedBox?.approved?.name || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-36"
              inline={true}>
              <label
                id="CardReturnDrugWorkingUX-label-45">
                {props.languageUX === "en" ? "Day-time" : "วัน-เวลา"}
              </label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-37"
              inline={true}
              width={3}>
              <Input
                fluid={true}
                id="CardReturnDrugWorkingUX-Input-51"
                ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#DFDFDF",ref.inputRef.current.style.borderColor = "#DBDBDB")}
                style={{width: "100%"}}
                value={props.orderDatetime?.approved|| ""}>
              </Input>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-106"
              inline={true}>
              <label
                id="CardReturnDrugWorkingUX-label-107">
                {props.languageUX === "en" ? "department" : "แผนก"}
              </label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-114"
              inline={true}
              width={3}>
              <Input
                fluid={true}
                id="CardReturnDrugWorkingUX-Input-115"
                ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#DFDFDF",ref.inputRef.current.style.borderColor = "#DBDBDB")}
                style={{width: "100%"}}
                value={props.DrugReturnRequestHistorySequence?.selectedBox?.approved?.division || ""}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardReturnDrugWorkingUX-FormGroup-29"
            inline={true}>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-38"
              inline={true}>
              <label
                id="CardReturnDrugWorkingUX-label-46"
                style={{width: "70px"}}>
                {props.languageUX === "en" ? "Sender" : "ผู้ส่ง"}
              </label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-39"
              inline={true}
              width={3}>
              <Input
                fluid={true}
                id="CardReturnDrugWorkingUX-Input-52"
                ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#DFDFDF",ref.inputRef.current.style.borderColor = "#DBDBDB")}
                style={{width: "100%"}}
                value={props.DrugReturnRequestHistorySequence?.selectedBox?.delivered?.name || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-40"
              inline={true}>
              <label
                id="CardReturnDrugWorkingUX-label-47">
                {props.languageUX === "en" ? "Day-time" : "วัน-เวลา"}
              </label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-41"
              inline={true}
              width={3}>
              <Input
                fluid={true}
                id="CardReturnDrugWorkingUX-Input-53"
                ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#DFDFDF",ref.inputRef.current.style.borderColor = "#DBDBDB")}
                style={{width: "100%"}}
                value={props.orderDatetime?.delivered||""}>
              </Input>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-108"
              inline={true}>
              <label
                id="CardReturnDrugWorkingUX-label-109">
                {props.languageUX === "en" ? "department" : "แผนก"}
              </label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-116"
              inline={true}
              width={3}>
              <Input
                fluid={true}
                id="CardReturnDrugWorkingUX-Input-117"
                ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#DFDFDF",ref.inputRef.current.style.borderColor = "#DBDBDB")}
                style={{width: "100%"}}
                value={props.DrugReturnRequestHistorySequence?.selectedBox?.delivered?.division || ""}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardReturnDrugWorkingUX-FormGroup-95"
            inline={true}>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-96"
              inline={true}>
              <label
                id="CardReturnDrugWorkingUX-label-97"
                style={{width: "70px"}}>
                {props.languageUX === "en" ? "recipient" : "ผู้รับ"}
              </label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-98"
              inline={true}
              width={3}>
              <Input
                fluid={true}
                id="CardReturnDrugWorkingUX-Input-99"
                ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#DFDFDF",ref.inputRef.current.style.borderColor = "#DBDBDB")}
                style={{width: "100%"}}
                value={props.DrugReturnRequestHistorySequence?.selectedBox?.received?.name || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-100"
              inline={true}>
              <label
                id="CardReturnDrugWorkingUX-label-101">
                {props.languageUX === "en" ? "Day-time" : "วัน-เวลา"}
              </label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-102"
              inline={true}
              width={3}>
              <Input
                fluid={true}
                id="CardReturnDrugWorkingUX-Input-103"
                ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#DFDFDF",ref.inputRef.current.style.borderColor = "#DBDBDB")}
                style={{width: "100%"}}
                value={props.orderDatetime?.received||""}>
              </Input>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-110"
              inline={true}>
              <label
                id="CardReturnDrugWorkingUX-label-111">
                {props.languageUX === "en" ? "department" : "แผนก"}
              </label>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-118"
              inline={true}
              width={3}>
              <Input
                fluid={true}
                id="CardReturnDrugWorkingUX-Input-119"
                ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#DFDFDF",ref.inputRef.current.style.borderColor = "#DBDBDB")}
                style={{width: "100%"}}
                value={props.DrugReturnRequestHistorySequence?.selectedBox?.received?.division || ""}>
              </Input>
            </FormField>
          </FormGroup>
        </div>
        <div
          className="ui form"
          id="CardReturnDrugWorkingUX-div-54">

          <div
            id="CardReturnDrugWorkingUX-div-79"
            style={{width: "100%"}}>
            {props.TopTable}
          </div>
          <Table
            data={props.items || []}
            getTdProps={props.getTdProps}
            getTheadThProps={props.getTheadThProps}
            getTrProps={props.getTrProps}
            headers="ลำดับ,รหัสยา,ชื่อยา,จำนวนจ่าย,จำนวนคงเหลือ,จำนวนขอคืน,จำนวนรับคืนเข้าคลัง,จำนวนจ่ายรับคืนทำลาย,เหตุผล,หน่วย"
            id="CardReturnDrugWorkingUX-Table-56"
            keys="no,code,name,quantity_issue,quantity_left,quantity_request,quantity_restock,quantity_discard,reason,stock_unit_name"
            minRows="4"
            showPagination={false}
            style={{height: "200px"}}
            widths="50,100,,100,100,100,100,100,150,100">
          </Table>
          <div
            id="CardReturnDrugWorkingUX-div-84">
            {props.ErrorMessage}
          </div>
        </div>
        <div
          className="ui form"
          id="CardReturnDrugWorkingUX-div-57"
          style={{marginTop: "2rem"}}>

          <FormGroup
            id="CardReturnDrugWorkingUX-FormGroup-58"
            inline={true}>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-59"
              inline={true}>
            </FormField>
            <div
              className="field"
              id="CardReturnDrugWorkingUX-div-61"
              style={{flex: 1}}>

            </div>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-60"
              inline={true}>
              <div
                id="CardReturnDrugWorkingUX-div-81">
                {props.buttonBackward}
              </div>
            </FormField>
            <FormField
              id="CardReturnDrugWorkingUX-FormField-85">
              <div
                id="CardReturnDrugWorkingUX-div-82">
                {props.buttonForward}
              </div>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}

CardReturnDrugWorkingUX.displayName = "CardReturnDrugWorkingUX";
export default React.memo(CardReturnDrugWorkingUX)

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 16:46:37 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\", padding: \"10px\",  height: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-div-2"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "คืนยากลับเข้าห้องยา",
          "valueEN": "Return the medicine to the pharmacy."
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"1.5rem\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่ใบยา",
          "valueEN": "Drug leaf number"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-label-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "Label",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DrugReturnRequestHistorySequence?.selectedBox?.order_code || \"-\""
        },
        "className": {
          "type": "value",
          "value": "large"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Label-10"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"#C3F4FF\", color: \"rgba(0,0,0,.87)\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-div-11"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormGroup",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormGroup-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormGroup",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormGroup-28"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormGroup",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormGroup-29"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-30"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-31"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-32"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-33"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormField",
      "parent": 28,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-34"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormField",
      "parent": 28,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-35"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 28,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-36"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 28,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-37"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-38"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-39"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-40"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-41"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "label",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ขอคืน",
          "valueEN": "Refund Requester"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-label-42"
        },
        "style": {
          "type": "code",
          "value": "{width: \"70px\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "label",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": "วัน-เวลา",
          "valueEN": "Day-time"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-label-43"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "label",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้อนุมัติ",
          "valueEN": "Approver"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-label-44"
        },
        "style": {
          "type": "code",
          "value": "{width: \"70px\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "label",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": "วัน-เวลา",
          "valueEN": "Day-time"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-label-45"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "label",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ส่ง",
          "valueEN": "Sender"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-label-46"
        },
        "style": {
          "type": "code",
          "value": "{width: \"70px\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "label",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "วัน-เวลา",
          "valueEN": "Day-time"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-label-47"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "Input",
      "parent": 31,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Input-48"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#DFDFDF\",ref.inputRef.current.style.borderColor = \"#DBDBDB\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.DrugReturnRequestHistorySequence?.selectedBox?.requested?.name || \"\""
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "Input",
      "parent": 33,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Input-49"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#DFDFDF\",ref.inputRef.current.style.borderColor = \"#DBDBDB\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.orderDatetime?.requested || \"\""
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "Input",
      "parent": 35,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Input-50"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#DFDFDF\",ref.inputRef.current.style.borderColor = \"#DBDBDB\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.DrugReturnRequestHistorySequence?.selectedBox?.approved?.name || \"\""
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "Input",
      "parent": 37,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Input-51"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#DFDFDF\",ref.inputRef.current.style.borderColor = \"#DBDBDB\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.orderDatetime?.approved|| \"\""
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "Input",
      "parent": 39,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Input-52"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#DFDFDF\",ref.inputRef.current.style.borderColor = \"#DBDBDB\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.DrugReturnRequestHistorySequence?.selectedBox?.delivered?.name || \"\""
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "Input",
      "parent": 41,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Input-53"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#DFDFDF\",ref.inputRef.current.style.borderColor = \"#DBDBDB\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.orderDatetime?.delivered||\"\""
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-div-54"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 56,
      "name": "Table",
      "parent": 54,
      "props": {
        "data": {
          "type": "code",
          "value": "props.items || []"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.getTdProps"
        },
        "getTheadThProps": {
          "type": "code",
          "value": "props.getTheadThProps"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": "ลำดับ,รหัสยา,ชื่อยา,จำนวนจ่าย,จำนวนคงเหลือ,จำนวนขอคืน,จำนวนรับคืนเข้าคลัง,จำนวนจ่ายรับคืนทำลาย,เหตุผล,หน่วย"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Table-56"
        },
        "keys": {
          "type": "value",
          "value": "no,code,name,quantity_issue,quantity_left,quantity_request,quantity_restock,quantity_discard,reason,stock_unit_name"
        },
        "minRows": {
          "type": "value",
          "value": "4"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"200px\"}"
        },
        "widths": {
          "type": "value",
          "value": "50,100,,100,100,100,100,100,150,100"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"2rem\"}"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "FormGroup",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormGroup-58"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormField",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-59"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormField",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-60"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "field"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 54,
      "props": {
        "children": {
          "type": "code",
          "value": "props.TopTable"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-div-79"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "div",
      "parent": 60,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonBackward"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-div-81"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonForward"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-div-82"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "div",
      "parent": 54,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ErrorMessage"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-div-84"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "FormField",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-85"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DrugReturnRequestHistorySequence?.selectedBox?.code || \"-\""
        },
        "className": {
          "type": "value",
          "value": "ui label brown ribbon"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-div-92"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "Label",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DrugReturnRequestHistorySequence?.selectedBox?.status_name || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Label-93"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "FormGroup",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormGroup-95"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "FormField",
      "parent": 95,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-96"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "label",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้รับ",
          "valueEN": "recipient"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-label-97"
        },
        "style": {
          "type": "code",
          "value": "{width: \"70px\"}"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "FormField",
      "parent": 95,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-98"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "Input",
      "parent": 98,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Input-99"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#DFDFDF\",ref.inputRef.current.style.borderColor = \"#DBDBDB\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.DrugReturnRequestHistorySequence?.selectedBox?.received?.name || \"\""
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "FormField",
      "parent": 95,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-100"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "label",
      "parent": 100,
      "props": {
        "children": {
          "type": "value",
          "value": "วัน-เวลา",
          "valueEN": "Day-time"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-label-101"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "FormField",
      "parent": 95,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-102"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "Input",
      "parent": 102,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Input-103"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#DFDFDF\",ref.inputRef.current.style.borderColor = \"#DBDBDB\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.orderDatetime?.received||\"\""
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 104,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-104"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "label",
      "parent": 104,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-label-105"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "FormField",
      "parent": 28,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-106"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "label",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-label-107"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "FormField",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-108"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "label",
      "parent": 108,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-label-109"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "FormField",
      "parent": 95,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-110"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": null,
      "id": 111,
      "name": "label",
      "parent": 110,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-label-111"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-112"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "Input",
      "parent": 112,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Input-113"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#DFDFDF\",ref.inputRef.current.style.borderColor = \"#DBDBDB\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.DrugReturnRequestHistorySequence?.selectedBox?.requested?.division || \"\""
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "FormField",
      "parent": 28,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-114"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "Input",
      "parent": 114,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Input-115"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#DFDFDF\",ref.inputRef.current.style.borderColor = \"#DBDBDB\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.DrugReturnRequestHistorySequence?.selectedBox?.approved?.division || \"\""
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "FormField",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-116"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "Input",
      "parent": 116,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Input-117"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#DFDFDF\",ref.inputRef.current.style.borderColor = \"#DBDBDB\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.DrugReturnRequestHistorySequence?.selectedBox?.delivered?.division || \"\""
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "FormField",
      "parent": 95,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-118"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 119,
      "name": "Input",
      "parent": 118,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Input-119"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#DFDFDF\",ref.inputRef.current.style.borderColor = \"#DBDBDB\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.DrugReturnRequestHistorySequence?.selectedBox?.received?.division || \"\""
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 125,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-125"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "label",
      "parent": 125,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วย",
          "valueEN": "patient"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-label-126"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 128,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-128"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "label",
      "parent": 128,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วยงาน",
          "valueEN": "Agency"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-label-129"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 130,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-130"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 131,
      "name": "Label",
      "parent": 130,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DrugReturnRequestHistorySequence?.selectedBox?.patient_name_code || \"-\""
        },
        "className": {
          "type": "value",
          "value": "large"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Label-131"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"#C3F4FF\", color: \"rgba(0,0,0,.87)\"}"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 132,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-FormField-132"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 133,
      "name": "Label",
      "parent": 132,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DrugReturnRequestHistorySequence?.selectedBox?.requester_name || \"-\""
        },
        "className": {
          "type": "value",
          "value": "large"
        },
        "id": {
          "type": "value",
          "value": "CardReturnDrugWorkingUX-Label-133"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"#C3F4FF\", color: \"rgba(0,0,0,.87)\"}"
        }
      },
      "seq": 133,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": true,
  "name": "CardReturnDrugWorkingUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
